export default __webpack_public_path__ + "e81223dcf8c4442647c83d696603e220.jpg";